/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React, { Component } from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import type { Store } from "../../store";

import logo_spwn from "../../designs/images/logo_spwn.svg";
/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
/* eslint-enable no-restricted-imports */

/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";
/* eslint-enable no-restricted-imports */
import { getDateTimeString } from "../../utility";
import BorderLoader from "../../components/atoms/loader/BorderLoader";
import type { MaintenanceInfo } from "@spwn/types/firebase/firestore";

type Props = {};

type State = {
  maintenanceInfo: null | MaintenanceInfo;
};

class Admin extends Component<Props, State> {
  _unsubscriber = null;
  state = {
    maintenanceInfo: {
      isFlowerStandMaintenance: false,
      isPawChargeMaintenance: false,
      isGoodsMaintenance: false,
      isTicketMaintenance: false,
      isLiveEventMaintenance: false,
      isMaintenance: false,
      startAt: null,
      endAt: null,
      msg: "",
      liveEventId: "",
    },
  };

  // @ts-expect-error TS7006
  constructor(props) {
    super(props);
    this.watcher();
  }

  componentWillUnmount(): void {
    if (this._unsubscriber !== null) {
      // @ts-expect-error TS2349
      this._unsubscriber();
      this._unsubscriber = null;
    }
  }

  watcher = () => {
    if (this._unsubscriber === null) {
      // @ts-expect-error TS2322
      this._unsubscriber = firebase
        .firestore()
        .doc("/management/maintenanceInfo")
        .onSnapshot((doc) => {
          const data = doc.data() as MaintenanceInfo;
          this.setState({ maintenanceInfo: data });
        });
    }
  };

  render() {
    console.log(this.state.maintenanceInfo.msg);
    const classesMaintenanceStyles = maintenanceStyles();
    const { maintenanceInfo } = this.state;

    if (maintenanceInfo.startAt === null || maintenanceInfo.endAt === null) {
      return <BorderLoader />;
    }

    return (
      <div css={classesMaintenanceStyles.root}>
        <div css={classesMaintenanceStyles.message}>
          <h1>
            <img src={logo_spwn} alt="spwn" />
          </h1>
          <p>{maintenanceInfo.msg}</p>
          <ul>
            {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
            <li>
              開始時刻：
              {getDateTimeString(
                // @ts-expect-error TS2339
                new Date(maintenanceInfo.startAt.seconds * 1000)
              )}
            </li>
            {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
            <li>
              終了時刻：
              {getDateTimeString(
                // @ts-expect-error TS2339
                new Date(maintenanceInfo.endAt.seconds * 1000)
              )}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (_state: Store) => {
  return {};
};
const mapDispatchToProps = (_dispatch: Dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Admin);

const maintenanceStyles = () => {
  return {
    root: css`
      width: 100%;
      height: 100vh;
      background-color: #000;
    `,
    message: css`
      position: absolute;
      top: 50%;
      left: 50%;
      width: 90%;
      margin: 0 auto;
      padding: 30px;
      border: 1px solid #fff;
      transform: translate(-50%, -50%);
      @media screen and (min-width: 768px) {
        width: 600px;
      }
      h1 {
        img {
          display: block;
          width: 200px;
          margin: 0 auto 30px;
        }
      }
      p {
        margin-bottom: 30px;
        color: #fff;
        text-align: center;
        font-weight: bold;
        line-height: 1.3em;
      }
      ul {
        li {
          margin-bottom: 10px;
          color: #fff;
          text-align: center;
        }
      }
    `,
  };
};
